<template>
  <div class="example-avatar">
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>{{ $t('common.imageUpload.drop') }}</h3>
    </div>
    <div class="avatar-upload" v-show="!edit">
      <div class="text-center p-2">
        <label for="avatar">
          <img
            :src="files.length ? files[0].url : defaultImage"
            class="rounded-circle center"
          />
        </label>
      </div>
      <div class="text-center p-2">
        <file-upload
          extensions="gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp"
          name="avatar"
          class="btn btn-primary"
          :post-action="apiUrl"
          :headers="authHeaderValue"
          :drop="!edit"
          v-model="files"
          @input-filter="inputFilter"
          @input-file="inputFile"
          ref="upload"
        >
          {{ $t('common.imageUpload.upload') }}
        </file-upload>
      </div>
    </div>

    <div class="avatar-edit" v-show="files.length && edit">
      <div class="avatar-edit-image" v-if="files.length">
        <img ref="editImage" :src="files[0].url" />
      </div>
      <div class="text-center p-4">
        <button
          type="button"
          class="btn btn-secondary"
          @click.prevent="$refs.upload.clear"
        >
          {{ $t('common.cancel') }}
        </button>
        <button type="submit" class="btn btn-primary" @click.prevent="editSave">
          {{ $t('common.save') }}
        </button>
      </div>
    </div>
  </div>
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-image-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('common.imageUpload.unsuported') }}</div>
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>
<style>
.example-avatar .avatar-upload .rounded-circle {
  width: 200px;
  height: 200px;
}
.example-avatar .text-center .btn {
  margin: 0 0.5rem;
}
.example-avatar .avatar-edit-image {
  max-width: 100%;
}

.example-avatar .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}

.example-avatar .drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
</style>

<script>
import Cropper from 'cropperjs'
import FileUpload from 'vue-upload-component'
import Toastify from 'toastify-js'
import 'cropperjs/dist/cropper.css'
import { defineComponent } from 'vue'
import authHeader from '@/services/security/auth.header'

export default defineComponent({
  components: {
    FileUpload
  },

  data() {
    return {
      files: [],
      edit: false,
      cropper: false
    }
  },

  watch: {
    edit(value) {
      if (value) {
        this.$nextTick(function () {
          if (!this.$refs.editImage) {
            return
          }
          this.cropper = new Cropper(this.$refs.editImage, {
            aspectRatio: this.aspectRatio,
            viewMode: 1
          })
        })
      } else {
        if (this.cropper) {
          this.cropper.destroy()
          this.cropper = false
        }
      }
    }
  },

  methods: {
    editSave() {
      this.edit = false

      const oldFile = this.files[0]

      const binStr = atob(
        this.cropper.getCroppedCanvas().toDataURL(oldFile.type).split(',')[1]
      )
      const arr = new Uint8Array(binStr.length)
      for (let i = 0; i < binStr.length; i++) {
        arr[i] = binStr.charCodeAt(i)
      }

      const file = new File([arr], oldFile.name, { type: oldFile.type })

      this.$refs.upload.update(oldFile.id, {
        file,
        type: file.type,
        size: file.size,
        active: true
      })
    },

    inputFile(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        this.$nextTick(function () {
          this.edit = true
        })
      }
      if (!newFile && oldFile) {
        this.edit = false
      }
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          console.info(newFile.name)
          Toastify({
            node: cash('#failed-image-content').clone().removeClass('hidden')[0],
            duration: 10000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          return prevent()
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = ''
        const URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file)
        }
      }
    },

    getValue() {
      if (
        this.files.length &&
        this.files[0].response !== {} &&
        this.files[0].response.data !== undefined
      ) {
        return this.files[0].response.data[0].uri
      }
      return null
    }
  },

  props: {
    defaultImage: {
      type: String,
      default: () => 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'
    },
    aspectRatio: {
      type: Number,
      default: () => 1 / 1
    }
  },

  setup(props, { emit }) {
    const authHeaderValue = authHeader()
    const superAdmin = localStorage.getItem('auth_superadmin')
    const editor = localStorage.getItem('auth_editor')

    const apiUrl =
      superAdmin === true || superAdmin === 'true' || editor === true || editor === 'true'
        ? process.env.VUE_APP_BASE_API_URL + '/api/v1/super-admin/cdn/upload'
        : process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/cdn/upload'

    return {
      authHeaderValue,
      apiUrl
    }
  }
})
</script>
